import { useEffect, useState } from "react";
import { getCateringMenuItems } from "../services/dashboard";

interface CateringMenuOption {
  templateItemId: string;
  itemName: string;
}

const categoryMap: Record<string, string> = {
  "MENU 1": "MENU_1",
  "MENU 2": "MENU_2",
  "MENU 3": "MENU_3",
  "MENU 4": "MENU_4",
};

export const useCateringMenuItems = (category?: string) => {
  const [menuItems, setMenuItems] = useState<CateringMenuOption[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const normalizedCategory = categoryMap[category?.trim().toUpperCase() || ""] || "";

    if (!normalizedCategory) {
      setMenuItems([]);
      return;
    }

    const fetchMenuItems = async () => {
      setLoading(true);
      const res = await getCateringMenuItems(normalizedCategory);

      if (res?.status === 200 && Array.isArray(res.data)) {
        setMenuItems(res.data);
      } else {
        setMenuItems([]);
      }

      setLoading(false);
    };

    fetchMenuItems();
  }, [category]);

  return {
    menuItems,
    loading,
  };
};
